import { useState } from 'react';
import { apiFetch } from '../../../context/AuthContext';

function useEmployees(userRole) {
    const apiBaseUrl = process.env.REACT_APP_BASE_URL;

    const [availableEmployees, setAvailableEmployees] = useState([]);

    const fetchAvailableEmployees = async () => {
        try {
            const headers = {};
            if (userRole === "manager") {
                headers['x-view-type'] = 'manager';
            }

            const res = await apiFetch(`${apiBaseUrl}/employees/visibility`, {
                method: "GET",
                headers
            });
            const data = await res.json();
            setAvailableEmployees(data.employees || []);
        } catch (err) {
            console.error('Error fetching employees:', err);
        }
    };

    return { availableEmployees, fetchAvailableEmployees };
}

export default useEmployees;